<template>
  <GlassPreviewLayout>
    <div v-for="index in layoutPhotoCount" :key="index" class="image">
      <Image
        :image-url="imageUrl(index)"
        :text="`${$t('Photo')} ${index}`"
        :uploader-id="`originalCollage${index}`"
      />
    </div>
    <slot></slot>
  </GlassPreviewLayout>
</template>
<script>
import GlassPreviewLayout from "../glass-preview/Layout";
import Placeholder from "../../../partials/Placeholder";
import usePhoto from "../../usePhoto";
import Image from "../Image";
import store from "../../../../store";

export default {
  components: {
    Image,
    Placeholder,
    GlassPreviewLayout,
  },
  computed:{
    imageUrl() {
      return (index) => this.getImageUrl(index);
    },
  },
  setup() {
    const { layoutPhotoCount, getImageUrl } = usePhoto();

    return {
      layoutPhotoCount,
      getImageUrl,
      store,
    };
  },
};
</script>
